import axios from "axios";
import React, { useState } from "react";
import { apiKey } from "../config/config";
import { convertDateFormat } from "../services/helper";

function ShiftComponenet({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const [closeShiftModal, setCloseShiftModal] = useState(false);
  const [shiftDetails, setShiftDetails] = useState();

  const checkShift = () => {
    const branchId = JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin")).admin
    ).branch_id;
    axios
      .get(apiKey + "/shift-data/" + branchId, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.Message === "No Active Shift") {
          setCloseShiftModal(false);
        } else {
          setShiftDetails(res.data.data);
          setCloseShiftModal(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const closeModal = () => {
    setCloseShiftModal(false);
  };

  return (
    <>
      <button onClick={checkShift} className="btn mx-auto mt-4 d-block">
        {lang["Daily Reports"] || "Daily Reports"}
      </button>

      {closeShiftModal && (
        <div className="modal-body-custom">
          <div className="modal-item-custom">
            <button
              onClick={closeModal}
              type="button"
              className="btn modal-close-btn"
            >
              <i className="fa fa-2x">×</i>
            </button>
            <h2>{lang["Daily Reports"] || "Daily Reports"}</h2>
            <div className="">
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Opening Time"] || "Opening Time"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {convertDateFormat(shiftDetails?.openingTime)}
                </span>
              </div>
              {/* <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Opening Amount"] || "Opening Amount"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.openingBalance}
                </span>
              </div> */}
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Contracts"] || "Total Contracts"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalContracts || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Contract Amount"] || "Total Contract Amount"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalContractAmount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Contract Payments"] || "Total Contract Payments"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalContractPayments || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Contract Payment Amount"] ||
                    "Total Contract Payment Amount"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalContractPaymentAmount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Withdrawals"] || "Total Withdrawals"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalWithdrawals || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Withdrawal Amount"] || "Total Withdrawal Amount"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalWithdrawalsAmount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Deposits"] || "Total Deposits"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalDeposits || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Total Deposit Amount"] || "Total Deposit Amount"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalDepositsAmount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Today's Profit"] || "Today's Profit"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.totalProfitAmount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {lang["Current Balance"] || "Current Balance"}
                </span>
                <span
                  className="text-primary"
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {shiftDetails?.currentBalance || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ShiftComponenet;
